'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _loader = require('signer/components/common/loader');

var _loader2 = _interopRequireDefault(_loader);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _signatureEditArea = require('./signature-edit-area');

var _signatureEditArea2 = _interopRequireDefault(_signatureEditArea);

var _reactIntl = require('react-intl');

var _propTypes = require('./prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PropTypes = _react2['default'].PropTypes;


var EmailTab = _react2['default'].createClass({
    displayName: 'EmailTab',


    propTypes: _extends({}, _propTypes.CommonTabProps, {
        isCheckingStatus: PropTypes.bool,
        onCheckStatus: PropTypes.func.isRequired,
        onSignatureData: _propTypes.OnSignatureData,
        onRotateSignature: PropTypes.func.isRequired,
        signature: _propTypes.SignatureType,
        uploadAddress: PropTypes.string.isRequired
    }),

    //  ----  BEHAVIOR  -----------------------------------

    insertSignature: function insertSignature(insertEverywhere) {

        var emailEditArea = this.refs.emailEditArea;
        var signatureData = {};
        var isCropped = emailEditArea.state.isCropped;

        if (isCropped) {
            signatureData = {
                'is_cropped': isCropped,
                'x': emailEditArea.state.cropX,
                'y': emailEditArea.state.cropY,
                'width': emailEditArea.state.cropWidth,
                'height': emailEditArea.state.cropHeight
            };
        }

        signatureData.create_type_code = _constants2['default'].SIGNATURE_TYPE_EMAIL;
        signatureData.threshold = emailEditArea.state.contrastValue;
        signatureData.degrees = emailEditArea.state.degreesValue;

        return this.props.onSignatureData(signatureData, insertEverywhere);
    },


    //  ----  HELPERS  ------------------------------------

    startSignatureFlow: function startSignatureFlow() {
        return this.props.onCheckStatus();
    },
    shouldDisableButtons: function shouldDisableButtons() {
        return !!this.props.signature;
    },
    onContinue: function onContinue() {
        this.startSignatureFlow();
    },


    //  ----  RENDERING  ----------------------------------

    render: function render() {
        var _props = this.props,
            actionBarProps = _props.actionBarProps,
            getSignatureUrl = _props.getSignatureUrl,
            intl = _props.intl,
            isCheckingStatus = _props.isCheckingStatus,
            onRotateSignature = _props.onRotateSignature,
            signature = _props.signature,
            type = _props.type;


        var spinner;

        var emailAddress = this.props.uploadAddress;

        var inputClasses = {
            'm-sign-modal--tabs--email--input': true };var classes = { 'm-sign-modal--tabs--email': true
        };
        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };

        containerClasses[_constants2['default'].TAB_EMAIL] = true;

        if (isCheckingStatus) {
            spinner = _react2['default'].createElement(_loader2['default'], {
                className: 'm-sign-modal--tabs--email--loader',
                'data-test-ref': 'loader' });
        }

        var steps = _react2['default'].createElement(
            'div',
            { className: 'm-sign-modal--tabs--email--steps' },
            _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--tabs--email--steps--header' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.email.instructions.header' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--tabs--email--steps--step' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.email.instructions.step_1', values: { type: this.props.type } })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--tabs--email--steps--step' },
                _react2['default'].createElement(
                    'p',
                    { style: { display: 'inline-block', width: 180, fontWeight: 'normal', lineHeight: '18px', fontSize: '14px' } },
                    _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.email.instructions.step_2' })
                ),
                _react2['default'].createElement(
                    'strong',
                    null,
                    emailAddress
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--tabs--email--steps--subject' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.email.instructions.subject' }),
                _react2['default'].createElement(
                    'strong',
                    null,
                    this.props.emailGuid
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--tabs--email--steps--step' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.email.instructions.step_3' })
            )
        );

        return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(containerClasses) },
            _react2['default'].createElement(
                'span',
                { className: 'm-sign-modal--tabs--tab-title' },
                _react2['default'].createElement(_reactIntl.FormattedMessage, {
                    id: 'signModal.email.title',
                    values: { type: this.props.type }
                })
            ),
            _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])(classes) },
                _react2['default'].createElement(
                    'div',
                    { className: (0, _classnames2['default'])(inputClasses) },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-sign-modal--tabs--content', ref: this.props.captureTabContentRef },
                        !signature && !isCheckingStatus && _react2['default'].createElement(
                            'div',
                            {
                                'data-test-ref': 'instructions',
                                className: 'm-sign-modal--tabs--email--part1' },
                            steps
                        ),
                        isCheckingStatus && spinner,
                        signature && _react2['default'].createElement(_signatureEditArea2['default'], {
                            'data-test-ref': 'edit-area',
                            getSignatureUrl: getSignatureUrl,
                            intl: intl,
                            onRotate: onRotateSignature,
                            ref: 'emailEditArea',
                            signature: signature,
                            type: type
                        })
                    )
                )
            ),
            _react2['default'].createElement(_actionBar2['default'], _extends({}, actionBarProps, {
                continueInsteadOfInsert: !signature,
                disableButtons: isCheckingStatus,
                onContinue: this.onContinue,
                onInsert: this.insertSignature
            }))
        );
    }
});

module.exports = EmailTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/email-tab.jsx
 ** module id = 797
 ** module chunks = 0 1
 **/